import styled from 'styled-components';

const MultiAccountContainerStyled = styled.div`
  border-right: none;
  padding: 16px 16px 0 24px;
  font-weight: bold;
  width: 100%;
  header {
    display: flex;
    align-items: center;
    span {
      color: #0e141d;
      font-size: 18px;
      font-style: normal;
      font-weight: 700;
      line-height: 20px;
      margin-left: 5px;
    }
  }
  & .MuiFormControl-root {
    min-width: 240px;
  }
  @media screen and (min-width: 768px) {
    border-right: #ccc4d2 1px solid;
    width: auto;
    padding-bottom: 16px;
    & .MuiFormControl-root {
      min-width: 100%;
    }

    ${({ isMultiAccount, status }) =>
      isMultiAccount &&
      (status === 'created' || status === 'warning') &&
      `
      height: 100%;
        align-content: center;
      `};
  }
`;

export default MultiAccountContainerStyled;
